import React, { useState } from 'react'
import Chart from "react-apexcharts"
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Badge from 'react-bootstrap/Badge'
import ListGroup from 'react-bootstrap/ListGroup'
import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'

export default function UserStatistics(props) {

    const { userStatistics } = props
    const [key, setKey] = useState('graphical')

    const courseData = userStatistics && userStatistics.map(item => item.course_title)
    const pass = userStatistics && userStatistics.map(item => item.result_percentage.result_pass)
    const fail = userStatistics && userStatistics.map(item => item.result_percentage.result_fail)

    const series = [
        {
            name: 'Passed',
            data: pass,
        },
        {
            name: 'Failed',
            data: fail,
        },
    ];

    var options = {
        chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: true
            }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                }
            }
        }],
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 10,
                dataLabels: {
                    total: {
                        enabled: true,
                        style: {
                            fontSize: '13px',
                            fontWeight: 900
                        }
                    }
                }
            },
        },
        xaxis: {
            type: 'Course',
            categories: courseData ? courseData : [],
            labels: {
                rotate: -90,
            },
        },
        legend: {
            position: 'top'

        },
        fill: {
            opacity: 1
        },
        colors: ["#008ffb", "#ff4560"]
    }

    return (
        <>
            <div className='container'>
                <div className='dash_head'>
                    <h5>User Statistics</h5>
                </div>

                {userStatistics && userStatistics.length ?
                    <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-3"
                        style={{ fontSize: '13px' }}
                    >
                        <Tab eventKey="graphical" title="Graphical">
                            <Chart options={options} series={series} type="bar" height='auto' width='100%' />
                        </Tab>
                        <Tab eventKey="tabular" title="Tabular">
                            <PerfectScrollbar>
                                <ListGroup as="ol" style={{ height: '300px' }}>
                                    {userStatistics && userStatistics.map((val, index) =>
                                        <ListGroup.Item
                                            as="li"
                                            className="d-flex justify-content-between align-items-start"
                                            key={index}
                                        >
                                            <div className="ms-2 me-auto">
                                                <div className="fw-bold">{val.course_title}</div>
                                            </div>
                                            <Badge bg="primary" pill>
                                                {val.result_percentage && val.result_percentage.result_pass}
                                            </Badge>
                                            <Badge bg="danger" pill className='ms-2'>
                                                {val.result_percentage && val.result_percentage.result_fail}
                                            </Badge>
                                        </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </PerfectScrollbar>
                        </Tab>
                    </Tabs>
                    :
                    <h6>User Statistics not found!</h6>
                }
            </div>
        </>
    )
}






